module.exports = __webpack_public_path__ + "static/img/logo_certisign_24_white.bdefcd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_certisign_24_white.png
// module id = 72
// module chunks = 0